export class SearchParamsUtil {
    static formToSearchParams(form: HTMLFormElement): Record<string, string> {
        const formData = new FormData(form);
        const params: Record<string, string> = {};
        formData.forEach((value, key) => {
            if (typeof value === "string") {
                params[key] = value;
            }
        });
        return params;
    }

    static getNumber(searchParams: URLSearchParams, key: string): number | undefined {
        const value = searchParams.get(key);
        if (value === null || value === "") {
            return undefined;
        }
        const num = +value;
        return isNaN(num) ? undefined : num;
    }

    static getString(searchParams: URLSearchParams, key: string): string | undefined {
        const value = searchParams.get(key);
        if (value === null) {
            return undefined;
        }
        return value as string;
    }

    static getYmd(searchParams: URLSearchParams, key: string): string | undefined {
        const value = searchParams.get(key);
        if (value === null || value === "") {
            return undefined;
        }
        return value;
    }

    // YYYY-MM-DD 형식의 문자열을 초단위 timestamp 로 변환
    static getTs(searchParams: URLSearchParams, key: string): number | undefined {
        const value = searchParams.get(key);
        if (value === null || value === "") {
            return undefined;
        }
        const date = new Date(value);
        if (isNaN(date.getTime())) {
            return undefined;
        }
        return Math.round(date.getTime() / 1000);
    }
}